import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class VoltageReferenceAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normTolerance = 1;
		this.normTaMin = 30;
		this.normTaMax = 1;
		this.normIr = 1;

		this.rankTolerance = 0;
		this.rankTaMin = 0;
		this.rankTaMax = 0;
		this.rankIr = 0;

		this.weightTolerance = 0.15;
		this.weightTaMin = 0.1;
		this.weightTaMax = 0.1;
		this.weightIr = 0.15;

		this.rTolerance = 0;
		this.rTaMin = 0;
		this.rTaMax = 0;
		this.rIr = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,' +
					'part_Tolerance,rTolerance,rankTolerance,' +
					'part_TaMin,rTaMin,rankTaMin,' +
					'part_TaMax,rTaMax,rankTaMax,' +
					'part_Ir,rIr,rankIr,' +
					'feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);
		// ---------------------------------------------Tolerance (%)---------------------------------------------

		[this.rankTolerance, this.rTolerance] = this.calculateRankSingleSliderLTE(
			CIDS.TOLERANCE,
			product,
			this.normTolerance
		);

		// ---------------------------------------------Ambient temperature Min  TA Min (°C)---------------------------------------------

		[this.rankTaMin, this.rTaMin] = this.calculateRankSingleSliderLTE(CIDS.T_A_MIN, product, this.normTaMin);

		// ---------------------------------------------Ambient temperature Max  TA Max (°C)---------------------------------------------

		[this.rankTaMax, this.rTaMax] = this.calculateRankSingleSliderGTE(CIDS.T_A_MAX, product, this.normTaMax);

		// ---------------------------------------------Reverse current  IR Min (mA)---------------------------------------------

		[this.rankIr, this.rIr] = this.calculateRankSingleSliderLTE(CIDS.I_R_MIN, product, this.normIr);

		// -------------------------------------------------------------------------------------------

		let feRank =
			this.weightTolerance * this.rankTolerance +
			this.weightTaMin * this.rankTaMin +
			this.weightTaMax * this.rankTaMax +
			this.weightIr * this.rankIr;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank =
			(1 - this.weightTolerance - this.weightTaMin - this.weightTaMax - this.weightIr) * super.execute(product) +
			feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
